import { ComponentFactoryResolver, ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';

@Injectable()
export class NgxResponsiveTableService {
  constructor(private factoryResolver: ComponentFactoryResolver) {
  }

  public getComponentInstance<T>(rootViewContainer: ViewContainerRef, componentType: Type<T>): ComponentRef<T> {
    const factory = this.factoryResolver.resolveComponentFactory(componentType);
    return factory.create(rootViewContainer.parentInjector);
  }

  public addDynamicComponent<T>(rootViewContainer: ViewContainerRef, componentType: Type<T>) {
    const component = this.getComponentInstance(rootViewContainer, componentType);

    rootViewContainer.insert(component.hostView);
  }
}
